<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="DeleteSchedule-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="DeleteSchedule-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="DeleteSchedule-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="DeleteSchedule-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <path class="DeleteSchedule-st2" d="M67.79,33.16h13.35c3.05,0,5.53,2.47,5.53,5.53V54.8c0,3.05-2.47,5.53-5.53,5.53H67.79c-3.05,0-5.53-2.47-5.53-5.53V38.68C62.26,35.63,64.73,33.16,67.79,33.16z"/>
            <path class="DeleteSchedule-st3" d="M32.33,33.16h13.35c3.05,0,5.53,2.47,5.53,5.53V54.8c0,3.05-2.47,5.53-5.53,5.53H32.33c-3.05,0-5.53-2.47-5.53-5.53V38.68C26.8,35.63,29.28,33.16,32.33,33.16z"/>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.DeleteSchedule_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.DeleteSchedule_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="DeleteSchedule-button lxn-margin-auto lxn-w100">
      <CustomButton  @click="DeleteSchedule" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.DeleteSchedule_button}}
      </CustomButton>
    </div>
    <div class="DeleteSchedule-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next2" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
        {{$store.getters.language.texts.DeleteSchedule_button2}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import * as CONFIGS from '@/statics/configs.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'

export default {
  name: 'DeleteSchedule',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton
  },
  data: function () {
    return {
      widgetIndex: Math.floor(this.$route.params.widgetIndex),
    }
  },
  computed: {
    widget: function () {
      return this.$store.state.widgets[this.widgetIndex];
    },
  },
  methods: {
    goBack: function () {
        // this.$store.commit("deleteSchedule", 0);
        // this.$store.commit("deleteSchedule", 1);
        // this.$store.commit("saveState");
      this.$router.go(-1);
    },
    DeleteSchedule: async function () {
      this.$store.commit('setAppBusy', true);
      var hubUUID = this.$route.params.hubUUID;
      var hub = this.$store.getters.getHubByUUID(hubUUID);
      var eventIdToWatch = parseInt(this.$route.params.eventIdToWatch);
      console.log("eventIdToWatch", eventIdToWatch);
      let scheduleToDelete = this.$store.getters.getScheduleForHubByEventId(hubUUID,eventIdToWatch);
      console.log("scheduleToDelete", scheduleToDelete);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });

      try {
        var schedulesList = await this.$store.dispatch('readHubSchedules', {messagingHook: messagingHook,hubUUID: hub.uuid});
        schedulesList = schedulesList.body.bodyContent.schedulesList;
        console.log("scheduleToDelete.type == ", scheduleToDelete.type == 2);
        console.log("scheduleToDelete.hasSecondary == true", scheduleToDelete.hasSecondary == true );
        console.log("schedulesList", schedulesList);
        let secondaryScheduleEventId = scheduleToDelete.type == 2 && scheduleToDelete.hasSecondary == true ? schedulesList[scheduleToDelete.index+1].eventId: -1 ;
        console.log("secondaryScheduleEventId", secondaryScheduleEventId);
        // if (scheduleToDelete != undefined) {
        //   throw "wait wait let me tell you something";
        // }

        var newSchedulesList = [];
        for(var i = 0; i < schedulesList.length; i++){
          var fetchedSchedule = schedulesList[i];
          if( fetchedSchedule.eventId != eventIdToWatch && fetchedSchedule.eventId != secondaryScheduleEventId ){
            newSchedulesList.push(fetchedSchedule);
          }
        }
        await this.$store.dispatch('setHubSchedules', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          bodyContent: {
            schedulesList: newSchedulesList,
          }
        })
        var maskList = [];
        maskList.push({
          eventId: eventIdToWatch,
          isMasked: false,
        });
        if (secondaryScheduleEventId != -1) {
          maskList.push({
            eventId: secondaryScheduleEventId,
            isMasked: false,
          });
          // this next mask is for disabling the notification
          let secondarySchedule = this.$store.getters.getScheduleForHubByEventId(hubUUID,secondaryScheduleEventId);
          console.log("secondarySchedule", secondarySchedule)
          // if (scheduleToDelete != undefined) {
          //   throw "wait wait let me tell you something";
          // }
          for (let k=0; k < scheduleToDelete.commandMaskList.length; k++) {
            let mask = scheduleToDelete.commandMaskList[k];
            maskList.push({
              eventId: mask.eventId,
              isMasked: true
            })
          }
        }  
        await this.$store.dispatch('setEventMasks', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          bodyContent: {
            maskList: maskList
          }
        })
        var instructionsList = [];
        instructionsList.push({
          eventIdToWatch: eventIdToWatch
        });
        await this.$store.dispatch('deleteHubInstructionsByEventId', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          bodyContent: {
            instructionsList: instructionsList
          }
        })
        var imitatorsList = await this.$store.dispatch('getUplinkImitators', {messagingHook: messagingHook,hubUUID: hub.uuid,});
        imitatorsList = imitatorsList.body.bodyContent.imitatorsList;

        var newImitatorsList = [];
        for(i = 0; i < imitatorsList.length; i++){
          if(imitatorsList[i].eventIdToWatch !== eventIdToWatch  && imitatorsList[i].eventIdToWatch != secondaryScheduleEventId){
            newImitatorsList.push(imitatorsList[i]);
          }
        }
        await this.$store.dispatch('setUplinkImitator', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          imitatorsList: newImitatorsList,
        })

        var schedule = this.$store.getters.getScheduleForHubByEventId(hubUUID, eventIdToWatch);
        if(schedule != -1){
          this.$store.commit("deleteSchedule", schedule.index);
          if (secondaryScheduleEventId != -1) {
            this.$store.commit("deleteSchedule", scheduleToDelete.index+1);
          }
        }
        this.$router.push('/schedules/');
        this.$store.commit('setAppBusy', false);
      }
      catch (response) {
        console.log("error", response);
        if(response.rejectCode == 2){
          this.$router.push('/SettingsHubError');
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }else{
          alert(this.$store.getters.language.texts.DeleteSchedule_alertDeleteError);
          this.$router.push('/SettingsHubError');
        }
        this.$store.commit('setAppBusy', false);
      }
    },
    next2: function () {
      this.$router.go(-1);
    }
  }
}
</script>

<style>
  .DeleteSchedule-topCurve-wrapper {
    height: 200px;
  }
  .DeleteSchedule-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .DeleteSchedule-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.DeleteSchedule-st0 {
    fill: #ECECEC;
  }
	.DeleteSchedule-st1 {
    fill: #53636C;
  }
	.DeleteSchedule-st2 {
    fill: #1EA5DE;
  }
	.DeleteSchedule-st3 {
    fill: #F36C4F;
  }
</style>
